import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '@hellodarwin/core/lib/components/common/div';
import React from 'react';
import { useTheme } from 'styled-components';
import MenuItemLabel from './menu-item-label';
import { SubNavigationSectionLabel } from './styles';
const SubNavigationMenuItemsList = ({ items, isCollapsed, handleLinkClick, removeBorder, }) => {
    const theme = useTheme();
    const hasSectionLabels = items.some(({ sectionLabel }) => !!sectionLabel);
    return (_jsxs(Div, { flex: "row", gap: 12, align: "stretch", style: {
            paddingLeft: isCollapsed || removeBorder
                ? 0
                : `${theme.appearance.spacing * 3.4}px`,
            marginBlockEnd: `${!isCollapsed && !removeBorder ? theme.appearance.spacing * 1 : 0}px`,
        }, children: [!isCollapsed && !removeBorder && (_jsx("div", { style: { width: 1, borderLeft: `1px solid ${theme.colors.grey_4}` } })), _jsx(Div, { flex: "column", gap: isCollapsed ? `${theme.appearance.spacing * 0.5}px` : 0, children: items.map((itm, index) => (_jsxs(React.Fragment, { children: [!!itm.sectionLabel && (_jsx(SubNavigationSectionLabel, { "$separated": index > 0, children: itm.sectionLabel })), _jsx(MenuItemLabel, Object.assign({}, itm, { handleLinkClick: handleLinkClick, isSectionItem: hasSectionLabels || undefined, isSublink: true }))] }, itm.pathname))) })] }));
};
export default SubNavigationMenuItemsList;
